export default {
    All: '1',
    League: '2',
    Tournament: '3',
}

export const EventTypeDescription = {
  Tournament: 'Tournament',
  League: 'League',
}


// WEBPACK FOOTER //
// ./src/utils/constants/eventtype.js